<template>
  <div
    class="cxm-Tag"
    :class="classes"
    v-on="$listeners"
  >
    <slot name="leftIcons" />
    <span :class="textClasses">
      <slot>{{ text }}</slot>
    </span>
    <slot name="rightIcons" />
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    bold: {
      type: Boolean,
      default: false,
    },
    nowrap: {
      type: Boolean,
      default: false,
    },
    tagNew: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        '-active': this.active,
        '-big': this.big,
        '-block': this.block,
        '-bold': this.bold,
        '-clickable': this.$listeners.click,
        '-nowrap': this.nowrap,
        '-tagNew': this.tagNew,
      };
    },
    hasLeftIcons() {
      return Boolean(this.$slots.leftIcons);
    },
    hasRightIcons() {
      return Boolean(this.$slots.rightIcons);
    },
    textClasses() {
      return {
        'cxm-Tag-TextLeft': this.hasRightIcons,
        'cxm-Tag-TextRight': this.hasLeftIcons,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-Tag {
  display: inline-flex;
  height: calc(var(--track-spacing-md) + var(--track-spacing-sm));
  align-items: center;
  padding: 4px 8px;
  font-size: var(--track-font-size-xxs);
  line-height: 1;
  background-color: var(--track-color-bluegray-10);
  color: var(--track-color-bluegray-60);
  border-radius: 50px;
  box-sizing: border-box;

  &.-active {
    border: 1px solid var(--track-color-bluegray-80);
    color: var(--track-color-bluegray-80);
  }

  &.-tagNew {
    display: inline-flex;
    align-items: center;
    padding: var(--track-spacing-xs) var(--track-spacing-sm);
    font-size: var(--track-spacing-sm);
    font-weight: bold;
    height: calc(var(--track-spacing-sm) + var(--track-spacing-sm));
    line-height: 1;
    background-color: var(--track-color-positive-lightest);
    color: var(--track-color-positive-darkest);
    border-radius: 50px;
    box-sizing: border-box;
  }

  &.-block {
    flex: 1;
    width: 100%;
  }

  &.-big {
    height: auto;
    min-height: var(--track-spacing-lg);
    font-size: var(--track-font-size-xs);
    font-weight: var(--track-font-weight-medium);
    border-radius: var(--track-spacing-md);
  }

  &.-bold {
    font-weight: var(--track-font-weight-medium);
  }

  &.-clickable {
    cursor: pointer;
  }

  &.-nowrap {
    white-space: nowrap;
  }
}

.cxm-Tag-TextLeft {
  margin-right: var(--track-spacing-sm);
  width: 100%;
}

.cxm-Tag-TextRight {
  margin-left: var(--track-spacing-sm);
}
</style>
